import api from "../../api";
import publicApi from "../../checkout/publicApi";

export type GetVenuesParams = {
    sport?: 'pickle' | 'tennis' | 'padel'
    // Existing call sites pass arbitrary keys (search, page, lat/lng, etc.) — keep open via index.
    [key: string]: unknown
}

export const getVenues = async (data : GetVenuesParams | any) => {

    const res = await api.get("venues/", { params : data })
    return res.data
}

export const getVenuesForMap = async (data : any) => {
    const res = await api.get("venues/map/", { params : data })
    return res.data
}

export const getDetailVenueForMobile = async (id : string) => {
    const res = await api.get(`venues/map/${id}/`)
    return res.data
}

export const getCoachList = async (data : {
    search ?: string,
    page ?: number,
    page_size ?: number,
    fields?: string[],
    is_coach ?: boolean,
    is_host ?: boolean,
}) => {

    const res = await api.get("member/", { params : {...data, include_self : true, fields : data.fields?.join(',') }})

    return res.data
}

export const getVenueDetail = async ({id} : {id : string | undefined}) => {

    const res = await api.get(`venues/${id}/`)
    return res.data
}

export const getVenueEvents = async ({id, filterParams} : {id : string | undefined, filterParams : {
    time? : string | null,
    date? : string | null,
    min_date ?: string | null,
    type? : string | null,
    sport? : string | null,
    is_special_event? : boolean | null,
    available_only : boolean,
    sort? : string | null,
    page : number,
    page_size : number,
}}) => {
    // Strip null/undefined so we never send `?type=null` to the backend.
    const params = Object.fromEntries(
        Object.entries(filterParams).filter(([, v]) => v !== null && v !== undefined),
    )
    const res = await api.get(`venues/${id}/events/`, { params })
    return res.data
}

export const getEvent = async ({id} : { id : string | undefined}) => {
    
    const res = await api.get(`events/${id}/`)
    return res.data
}

export const patchEventCheckIn = async ({
  event_id,
  member_id,
  booking_id,
  checked_in,
}: {
  event_id: string
  member_id?: string
  booking_id?: string
  checked_in: boolean
}) => {
  const res = await api.patch(`events/${event_id}/check-in/`, { member_id, booking_id, checked_in })
  return res.data
}

export const getPublicEventNoAuth = async ({id} : { id : string | undefined}) => {
    // Public API call without authentication - for public event share pages
    const res = await publicApi.get(`events/${id}/`)
    return res.data
}

// Phase 02 plan 02-05 — venue open_for_bookings toggle (D-16, VEN-04).
export const patchVenueOpenForBookings = async ({venueId, open}: {venueId: string; open: boolean}) => {
    const res = await api.patch(`venues/${venueId}/`, {open_for_bookings: open})
    return res.data
}

export type AffectedBooking = {
    id: string
    player_name: string
    sport: string
    start_time: string
    refund_cents: number
}

export type AffectedBookingsResponse = {
    court_rentals: AffectedBooking[]
    private_lessons: AffectedBooking[]
    total_refund_cents: number
}

// PHASE-5 TODO: replace stub with real endpoint
// D-21: at Phase 2 ship time there are no court rentals or private lessons in the
// system, so the affected-bookings list is always empty. When Phase 5+ ships the
// rentals/lessons data, replace this body with:
//   const res = await api.get(`venues/${venueId}/affected_bookings/`)
//   return res.data
export const getVenueAffectedBookings = async (args: {venueId: string}): Promise<AffectedBookingsResponse> => {
    void args.venueId // PHASE-5 TODO: consume venueId when the real endpoint ships
    return { court_rentals: [], private_lessons: [], total_refund_cents: 0 }
}